export default __webpack_public_path__ + "c1fe4583a6dedf7543e3b4143fe392e3.png";